export const recommendedMenus = {
  "เนื้อย่างซอสแจ่วปลาร้า": {
    id: 1,
    imageCover: "/images/recommended-menus/neaufoyawng_1.jpg",
    name: "เนื้อย่างซอสแจ่วปลาร้า",
    image: [],
    Description: "แซ่บย้อนวัย ด้วยน้ำปลาร้าแซ่บระดับตำนาน \r\n บอกเลยว่า...จ๊าบบบบ \r\nใช้ปลาร้าเชฟไพรฑูรย์ สูตรนัวกลมกล่อม",
    process: [
      "วัตถุดิบ",
      "• เนื้อวัวส่วนสันนอก 300 กรัม ",
      "• พริกป่น 1 ช้อนโต๊ะ",
      "• ข้าวคั่ว 1 ช้อนโต๊ะ",
      "• ต้นหอม (ใส่ตามความชอบ)",
      "• ผงชูรส (ใส่หรือไม่ใส่ก็ได้ตามความชอบ)",
      "• ปลาร้าเชฟไพรฑูรย์ สูตรนัวกลมกล่อม 4 ช้อนโต๊ะ ",
      "• ดีวัวแท้ ตราเชฟไพรฑูรย์ (ตามความชอบ)",
      "",
      "วิธีทำ",
      "1. หมักเนื้อวัวสันนอกกับ พริกป่น ข้าวคั่ว น้ำปลาร้าเชฟไพรฑูรย์ และดีวัวแท้ตราเชฟไพรฑูรย์ ตามส่วนผสมข้างต้น หมักทิ้งไว้ 10 นาที",
      "2. นำเนื้อไปจี่บนกระทะที่ไฟแรงจัด ด้านละ 3 นาที ",
      "3. นำเนื้อขึ้นจากกระทะ พักเนื้อทิ้งไว้ 5-10 นาที ",
      "4. หั่นเนื้อเป็นชิ้นพอดีคำ พร้อมเสิร์ฟ ทานคู่กับผักสด หรือข้าวเหนียว",
    ],
    galleryImages: [
      "/images/recommended-menus/neaufoyawng_1.jpg",
      "/images/recommended-menus/neaufoyawng_2.jpg",
      "/images/recommended-menus/neaufoyawng_3.jpg",
      "/images/recommended-menus/neaufoyawng_4.jpg"
    ],
  },
  "เหลาไหลบัวกุ้งทูโทน": {
    id: 2,
    imageCover: "/images/recommended-menus/yam_gung_tu_ton_1.jpg",
    name: "เหลาไหลบัวกุ้งทูโทน",
    image: [],
    Description: "แซ่บย้อนวัย ด้วยน้ำปลาร้าแซ่บระดับตำนาน \r\n บอกเลยว่า...จ๊าบบบบ \r\nใช้ปลาร้าเชฟไพรฑูรย์ สูตรนัวกลมกล่อม",
    process: [
      "วัตถุดิบ",
      "• กุ้งขาว 500 กรัม ",
      "• ไหลบัว 100 กรัม",
      "• พริกสด พริกแห้ง 8-10 เม็ด",
      "• มะนาว 1 ลูก ",
      "• มะเขือเทศ 5 ลูก",
      "• น้ำปลาร้าเชฟไพรฑูรย์สูตรออริจินอล 3 ทัพพี ",
      "• น้ำตาลปี๊บ 1 ช้อนโต๊ะ ",
      "• ผงชูรส (ใส่หรือไม่ใส่ก็ได้ตามความชอบ)",
      "• โซดา 1 ขวด",
      "",
      "วิธีทำ",
      "1. ปลอกเปลือกกุ้ง ผาหลังเอาเส้นหลังออก และล้างน้ำให้สะอาด",
      "2. นำกุ้งแช่น้ำโซดา 10 นาที ",
      "3. แบ่งกุ้งออกมาลวก 250 กรัม ลวกในน้ำเดือดจัด 2-3 นาที จดตัวกุ้งเป็นสีขาวขุ่น และน็อคน้ำเย็นจัดทันที",
      "4. โขลกพริกพอแหลกใส่ส่วนผสม มะเขือเทศ น้ำมะนาว น้ำตาลปี๊บตามอัตราส่วนด้านบน โขลกส่วนผสมให้เข้ากัน ",
      "5. ใส่น้ำปลาร้าเชฟไพรฑูรย์ 3 ทัพพี คนน้ำปลาร้ากับส่วนผสมให้เข้ากันอีกครั้ง ",
      "6. ชิมรสชาติ : ปรับ เปรี้ยว เค็ม หวาน ตามความชอบ",
      "7. ใส่วัตถุดิบหลัก ไหลบัว กุ้งสด กุ้งสุก ขอมแขก ผักชีใบเรื่อย และคนให้เข้ากัน",
      "8. ตักเสิร์ฟ ทาคู่กับผักสด แคบหมู และขนมจีน ตามความชอบ",
    ],
    galleryImages: [
      "/images/recommended-menus/yam_gung_tu_ton_1.jpg"
    ],
  },
  "หมกหน่อไม้ใส่หมู 3 ชั้น": {
    id: 3,
    imageCover: "/images/recommended-menus/mok_no_mai_1.jpg",
    name: "หมกหน่อไม้ใส่หมู 3 ชั้น",
    image: [],
    Description: "แซ่บย้อนวัย ด้วยน้ำปลาร้าแซ่บระดับตำนาน \r\n บอกเลยว่า...จ๊าบบบบ \r\nใช้ปลาร้าเชฟไพรฑูรย์ สูตรพลัสเพิ่มเนื้อปลา 30%",
    process: [
      "วัตถุดิบ",
      "• หน่อไม้ลวก 1 กิโลกรัม ",
      "• หมูสามชั้นหั่นชิ้น 3 ขีด ",
      "• ข้าวเบือ 3 ช้อนโต๊ะ",
      "• พริกกะเหรี่ยง 15 เม็ด ",
      "• กระชาย 5 หัว",
      "• ตะไคร้ 2 ต้น  ",
      "• หอมแดง 3-5 หัว ",
      "• ใบมะกรูดฉีก 10 ใบ ",
      "• น้ำใบย่านาง 5 ทัพพี ",
      "• น้ำปลาร้าสูตรพลัสเพิ่มเนื้อปลา 30 %  2 ทัพพี",
      "• น้ำปลา 1 ช้อนโต๊ะ ",
      "• ใบแมงลัก 1 มัด  ",
      "",
      "วิธีทำ",
      "1. นำหน่อไม้ต้มมาขูดให้เป็นเส้น ๆ จากนั้นใช้มีดตัดให้ได้ความยาวประมาณ 3 นิ้ว แล้วนำมาพักไว้ ",
      "2. นำข้าวเบือลงครก โขลกให้ละเอียด และตักพักไว้ และนำพริกกะเหรี่ยง หอมแดง กระชายลงคลก โขลกให้พอแหลก และตะไคร้ทุบบุบๆ",
      "3. นำหน่อไม้ที่เคล้ากับเครื่องแกงใส่ลงในหม้อ จากนั้นใส่หมูสามชั้นหั่นชิ้นลงไป ปรุงรสด้วยน้ำใบย่านาง น้ำปลาร้าเชฟไพรฑูรย์ สูตรพลัสเพิ่มเนื้อปลา 30 % คลุกเคล้าให้เข้ากัน ",
      "4. ตั้งไฟกลาง และคอยคนบ่อยๆเพราะอาจจะติดก้นหม้อและไหม้ได้ ",
      "5. เมื่อหมูสุกแล้ว ใส่ใบมะกรูด และใบแมงลักลงไป คนให้เข้ากันและปิดไฟพร้อมเสิร์ฟ",
      "6. ตักเสิร์ฟทานคู่กับผักสด และข้าวเหนียวหรือข้าวสวยตามความชอบ",
      "",
      "เคล็ดลับ",
      "• ถ้าหน่อไม้เปรี้ยวหรือมีกลิ่นให้นำไปต้มหลาย ๆ น้ำจนกลิ่นหาย ",
      "• ข้าวเบือ คือนำข้าวสารข้าวเหนียวมาแช่ในน้ำให้อ่อนตัว ข้าวเบือนั้นจะช่วยทำให้อาหารมีความข้นมากขึ้น ",
      "• ใช้น้ำปลาร้าเชฟไพรฑูรย์สูตรพลัสเพิ่มเนื้อปลา จะทำให้หมกหน่อไม้ เข้มข้น รสชาติจัดจ้าน สไตล์อีสานขนานแท้",
    ],
    galleryImages: [
      "/images/recommended-menus/mok_no_mai_1.jpg",
      "/images/recommended-menus/mok_no_mai_2.jpg",
      "/images/recommended-menus/mok_no_mai_3.jpg",
      "/images/recommended-menus/mok_no_mai_4.jpg"
    ],
  },
  "ปลาดุกต้มน้ำปลาร้าทรงเครื่อง": {
    id: 4,
    imageCover: "/images/recommended-menus/tom_pla_duk_1.jpg",
    name: "ปลาดุกต้มน้ำปลาร้าทรงเครื่อง",
    image: [],
    Description: "แซ่บย้อนวัย ด้วยน้ำปลาร้าแซ่บระดับตำนาน \r\n บอกเลยว่า...จ๊าบบบบ \r\nใช้ปลาร้าเชฟไพรฑูรย์ สูตรพลัสเพิ่มเนื้อปลา 30%",
    process: [
      "วัตถุดิบ",
      "• ปลาดุกหั่นแว่น 1 กก",
      "• ข่า 5 แว่น",
      "• ตะไคร้ 3 ต้น",
      "• กระชาย 9 หัว",
      "• หอมแดง 9 หัว",
      "• กระเทียมจีน 10 กลีบ",
      "• ใบมะกรูดฉีก 7 ใบ",
      "• พริกแห้งคั่ว (ตามใจชอบ)",
      "• ต้นหอมซอย 3 ต้น",
      "• น้ำปลาร้าเชฟไพรฑูรย์สูตรพลัสเพิ่มเนื้อปลา 30 %  1 ถ้วยตวง",
      "• น้ำสะอาด 2 ลิตร",
      "• พริกลูกโดด (ตามความชอบ)",
      "",
      "วิธีทำ",
      "ขั้นตอนการเตรียมเนื้อปลา",
      "1. นำเกลือมาคลุกกับเนื้อปลาให้ทั่ว ล้างด้วยน้ำสะอาด 1 น้ำ",
      "2. นำน้ำซาวข้าวมาล้าง เทน้ำออก ล้างปลาด้วยน้ำสะอาดอีก 1 รอบ",
      "3. นำน้ำเดือดจัด มาราดบนตัวปลา เทน้ำออก",
      "4. บุบข่า ตะไคร้ หอมแดง กระเทียม กระชาย ให้พอแตก (บุบทีละอย่างนะคะ)",
      "5. คั่วพริกแห้งด้วยไฟอ่อนให้หอม จากนั้นนำไปตำหยาบๆ",
      "6. ฉีกใบมะกรูด หั่นต้นหอมเตรียมไว้",
      "7. ต้มน้ำจนเดือด ใส่น้ำปลาร้าเชฟไพรฑูรย์สูตรพลัสเพิ่มเนื้อปลา 30 %  ลงไป น้ำเดือดอีกครั้ง ใส่ข่า ตะไคร้ ใบมะกรูด กระชาย กระเทียม หอมแดง",
      "8. เมื่อน้ำเดือดอีกครั้ง ใส่เนื้อปลาลงไป ช้อนฟองออกเรื่อยๆ",
      "9. เมื่อเนื้อปลาสุกดีแล้ว ใส่ใบมะกรูดอีกรอบ เพื่อความเขียวสวยงาม ใส่พริกแห้งคั่ว ลูกโดด ต้นหอมซอย ปิดไฟ พร้อมเสิร์ฟ",
      "10. จัดเสิร์ฟทานคู่กับผักสด ข้าวสวย หรือขนมจีน ตามความชอบ",
      "",
      "เคล็ดลับ",
      "• ก่อนทานแนะนำโรยพริกป่นลงไปตามความชอบจะช่วยเพิ่มความหอมและความแซ่บมากยิ่งขึ้น",
    ],
    galleryImages: [
      "/images/recommended-menus/tom_pla_duk_1.jpg"
    ],
  },
  "ขนมจีนน้ำยาปลาดุก": {
    id: 5,
    imageCover: "/images/recommended-menus/khanom_chin_naam_ya_1.jpg",
    name: "ขนมจีนน้ำยาปลาดุก",
    image: [],
    Description: "แซ่บย้อนวัย ด้วยน้ำปลาร้าแซ่บระดับตำนาน \r\n บอกเลยว่า...จ๊าบบบบ \r\nใช้ปลาร้าเชฟไพรฑูรย์ สูตรพลัส เพิ่มเนื้อปลา 30%",
    process: [
      "วัตถุดิบ",
      "• ปลาดุก 1 ตัว",
      "• หอมแดง 3 หัว",
      "• กระเทียม 3 กลีบ",
      "• กระชาย 3 ราก",
      "• ตะไคร้ 1 ต้น",
      "• ใบมะกรูด 3 ใบ",
      "• ต้นหอม",
      "• รากผักชี",
      "• เกลือป่น",
      "• น้ำตาล",
      "• พริกแห้ง",
      "• น้ำปลาร้าเชฟไพรฑูรย์ สูตรพลัส เพิ่มเนื้อปลา 30%  4 ทัพพี",
      "",
      "วิธีทำ",
      "1. หั่นปลาดุกเป็นท่อน ล้างให้สะอาด ตั้งกระทะ ใส่น้ำสะอาดตะไคร้ทุบลงไป พอน้ำเดือด ใส่ปลาดุกลงไปต้มไม่ต้องคน พอสุกตักปลาดุกออกมาแกะก้างปลาออกและน้ำเนื้อปลาที่แกะไปตำให้ละเอียด",
      "2. นำกระเทียม หอมปลอกเปลือก กะชายและพริกแห้งใส่ลงไปหม้อเดิมต้มต่อจนทุกอย่างสุก จากนั้นนำออกมาตำหรือปั่นให้ละเอียด",
      "3. ตั้งหม้อใหม่ใส่รากผักชี และเนื้อปลาที่เราตำไว้ลงในหม้อ พอน้ำเดือดใส่เครื่องแกงที่ปั่นไว้ล่งไปและปรุงรสด้วยน้ำปลาร้า เกลือป่น น้ำตาล ตามชอบ ใส่ใบมะกรูดและต้นหอมหั่นลงไปจากนั้นปิดไฟทันที เป็นอันเสร็จเรียบร้อย",
      "4. ตักเสิร์ฟราดลงบนขนมจีน กินคูกกับผักสดตามความชอบ",
    ],
    galleryImages: [
      "/images/recommended-menus/khanom_chin_naam_ya_1.jpg"
    ],
  },
  "อ่อมปูนา": {
    id: 6,
    imageCover: "/images/recommended-menus/om-pu-na/02.jpg",
    name: "อ่อมปูนา",
    image: [],
    Description: "แซ่บย้อนวัย ด้วยน้ำปลาร้าแซ่บระดับตำนาน \r\n บอกเลยว่า...จ๊าบบบบ \r\nใช้ปลาร้าเชฟไพรฑูรย์ สูตรพลัสเพิ่มเนื้อปลา 30%",
    process: [
      "วัตถุดิบ",
      "• ปูนา",
      "• ผักชีลาว",
      "• ผักกวางตุ้ง",
      "• ต้นหอม",
      "• ใบแมงลัก",
      "• พริกสด",
      "• ตะไคร้",
      "• หอมแดง",
      "• น้ำปลาร้าเชฟไพรฑูรย์ สูตรพลัสเพิ่มเนื้อปลา 30 %",
      "",
      "วิธีทำ",
      "1. ล้างปูนาให้สะอาด แกะกระดองออก แกะขี้ปู หรือส่วนสีดำๆ ออก (ตรงนี้กลิ่นจะคาว) นำเนื้อ ขา ก้าม โขลกให้ละเอียด (ถ้าก้ามใหญ่ๆไม่ต้องเอามาโขลกนะคะ ไว้แกะกินเนื้อ อร่อยมากๆ)",
      "2. โขลกจนละเอียด ตักใส่ผ้าขาวเพื่อกรอง คั้นเอาน้ำปูออกมา 3-4 รอบ (เติมน้ำเปล่าผสมกับปูที่โขลก เติมน้ำทีละน้อยๆนะคะ) หรือคั้นจนน้ำเริ่มใส พอได้น้ำเนื้อปู เทใส่หม้อ ตั้งหม้อ เติมน้ำปลาร้าเชฟไพรฑูรย์สูตร พลัสเพิ่มเนื้อปล้า 30 %  1 ทัพพี พริกสดโขลก 5-10 เม็ดตามความชอบ พร้อมกับตะไคร้ทุบ และหอมแดงผ่าครึ่ง (ถ้าใครชอบแบบข้นมากๆ ก่อนนำน้ำเนื้อปูตั้งหม้อ ใส่ไข่สัก1-2 ฟอง คนให้เข้ากันตั้งหม้อ เนื้อจะข้นฟูน่ากิน)",
      "3. พอน้ำเริ่มเดือด ใส่ผักชี ต้นหอม ผักกวางตุ้ง ที่หั่นไว้ และก้ามปูใหญ่ๆ กระดองปู 4-5 กระดองที่แกะออก ล้างให้สะอาด (ประดับสวยๆ) ลงหม้อ ปรุงรสด้วย น้ำปลา ผงนัวนิดหน่อย ปิดหม้อ รอผักสุก พร้อมเสิร์ฟ",
    ],
    galleryImages: [
      "/images/recommended-menus/om-pu-na/02.jpg",
      "/images/recommended-menus/om-pu-na/01.jpg",
      "/images/recommended-menus/om-pu-na/03.jpg",
      "/images/recommended-menus/om-pu-na/04.jpg"
    ],
  },
  "ตำลาวกุ้งเต้น": {
    id: 7,
    imageCover: "/images/recommended-menus/tam-lao-kung-ten/01.jpg",
    name: "ตำลาวกุ้งเต้น",
    image: [],
    Description: "แซ่บย้อนวัย ด้วยน้ำปลาร้าแซ่บระดับตำนาน \r\n บอกเลยว่า...จ๊าบบบบ \r\nใช้ปลาร้าเชฟไพรฑูรย์ สูตรพลัสเพิ่มเนื้อปลา 30%",
    process: [
      "วัตถุดิบ",
      "• เส้นมะละกอสับ",
      "• มะเขือเทศ",
      "• พริกสด (พริกแห้ง เพิ่มความหอม และรสเผ็ดร้อนมากขึ้น)",
      "• มะนาว",
      "• กระเทียม",
      "• มะกอก",
      "• น้ำปลาร้าเชฟไพรฑูรย์ สูตรพลัสเพิ่มเนื้อปลา 30 %",
      "• น้ำตาลทราย",
      "• ผงชูรส",
      "• กุ้งเต้นสด",
      "",
      "วิธีทำ",
      "1. ใส่พริกกับกระเทียมลงในครกตำพอหยาบ จากนั้นฝานมะเขือเทศ มะกอก ตามลงตำให้พอเข้ากัน ปรุงรสด้วยน้ำปลาร้า สูตรพลัสเพิ่มเนื้อปลา 30 % น้ำตาลทราย ผงชูรส และมะนาว",
      "2. จากนั้นใส่เส้นมะละกอสับ ตำเคล้าให้เครื่องปรุงทั้งหมดเข้ากันดี ชิมรสชาติและปรุงเพิ่มได้ตามใจชอบ ตักใส่จานโรยกุ้งเต้นและเมล็ดกระถิน เสิร์ฟคู่กับแคบหมู และผักบุ้ง ขนมจีน",
    ],
    galleryImages: [
      "/images/recommended-menus/tam-lao-kung-ten/01.jpg",
      "/images/recommended-menus/tam-lao-kung-ten/02.jpg",
      "/images/recommended-menus/tam-lao-kung-ten/03.jpg",
      "/images/recommended-menus/tam-lao-kung-ten/04.jpg"
    ],
  },
  "สามชั้นย่างซอสน้ำปลาร้า": {
    id: 8,
    imageCover: "/images/recommended-menus/sam-chan-yang-sauce-nam-pla-ra/01.jpg",
    name: "สามชั้นย่างซอสน้ำปลาร้า",
    image: [],
    Description: "แซ่บย้อนวัย ด้วยน้ำปลาร้าแซ่บระดับตำนาน \r\n บอกเลยว่า...จ๊าบบบบ \r\nใช้ปลาร้าเชฟไพรฑูรย์ สูตรนัวกลมกล่อม",
    process: [
      "วัตถุดิบ",
      "• หมูสามชั้น",
      "• น้ำปลาร้าเชฟไพรฑูรย์ สูตรนัวกลมกล่อม",
      "• พริกป่น",
      "• ข้าวคั่ว",
      "",
      "วิธีทำ",
      "1. หั่นหมูสามชั้นเป็นชิ้นพอดีคำและตัดแต่งให้สวยงาม",
      "2. นำหมูสามชั้นมาเสียบไม้",
      "3. ปรุงซอสแจ่ว",
      "   • พริกป่น 1 ช้อนโต๊ะ",
      "   • ข้าวคั่ว 1 ช้อนโต๊ะ",
      "   • น้ำปลาร้าเชฟไพรฑูรย์ สูตรนัวกลมกล่อม 2 ทัพพี",
      "4. คนส่วนผสมให้เข้ากัน หลังจากนั้น นำหมูสามชั้นที่เสียบไม้ไว้ขึ้นเตาย่าง ย่างไฟอ่อนๆ เมื่อหมูสามชั้นเริ่มมีสีเหลืองสวยงาม นำซอสแจ่วที่ปรุงไว้ ค่อยๆทาลงไปบนหมู ย่างและทาซอสไปเรื่อยๆจนกว่ามหมูจะสุก",
      "5. เมื่อหมูสุกจัดเสิร์ฟทานคู่กับผักสด เช่น แตงกวา สลัดครอส หรือผักต่างๆตามความชอบ",
    ],
    galleryImages: [
      "/images/recommended-menus/sam-chan-yang-sauce-nam-pla-ra/01.jpg",
      "/images/recommended-menus/sam-chan-yang-sauce-nam-pla-ra/02.jpg",
      "/images/recommended-menus/sam-chan-yang-sauce-nam-pla-ra/03.jpg",
      "/images/recommended-menus/sam-chan-yang-sauce-nam-pla-ra/04.jpg"
    ],
  },
  "ตำซั่วเล็บมือนาง": {
    id: 9,
    imageCover: "/images/recommended-menus/tam-sua-lep-mue-nang/01.jpg",
    name: "ตำซั่วเล็บมือนาง",
    image: [],
    Description: "แซ่บย้อนวัย ด้วยน้ำปลาร้าแซ่บระดับตำนาน \r\n บอกเลยว่า...จ๊าบบบบ \r\nใช้ปลาร้าเชฟไพรฑูรย์",
    process: [
      "วัตถุดิบ",
      "• เล็บมือนาง",
      "• ขนมจีน",
      "• เมล็ดกระถิน",
      "• มะเขือเทศ",
      "• พริกสด (พริกแห้ง เพิ่มความหอม และรสเผ็ดร้อนมากขึ้น)",
      "• มะนาว",
      "• กระเทียม",
      "• มะกอก",
      "• น้ำปลาร้าเชฟไพรฑูรย์ สูตรใดก็ได้",
      "• น้ำตาลทราย",
      "",
      "วิธีทำ",
      "1. นำเล็บมือนางมาล้างให้สะอาด และแช่โซดา 5-10 นาที และนำไปลวกในน้ำเดือด 2-3 นาที",
      "2. ใส่พริกกับกระเทียมลงในครกตำพอหยาบ จากนั้นฝานมะเขือเทศ ตามลงตำให้พอเข้ากัน ปรุงรสด้วยน้ำปลาร้าเชฟไพรฑูรย์ น้ำตาลทราย ผงชูรส และมะนาว",
      "3. จากนั้นใส่ขนมจีน และเล็บมือนาง เคล้าให้เครื่องปรุงทั้งหมดเข้ากันดี ชิมรสชาติและปรุงเพิ่มได้ตามใจชอบ ตักใส่จานโรยเมล็ดกระถิน เสิร์ฟคู่กับแคบหมู และผักตามความชอบ",
    ],
    galleryImages: [
      "/images/recommended-menus/tam-sua-lep-mue-nang/01.jpg",
      "/images/recommended-menus/tam-sua-lep-mue-nang/02.jpg",
      "/images/recommended-menus/tam-sua-lep-mue-nang/03.jpg",
      "/images/recommended-menus/tam-sua-lep-mue-nang/04.jpg",
    ],
  },
  "ก้อยเนื้อวัว": {
    id: 10,
    imageCover: "/images/recommended-menus/koi-nuea-wua/01.jpg",
    name: "ก้อยเนื้อวัว",
    image: [],
    Description: "แซ่บย้อนวัย ด้วยน้ำปลาร้าแซ่บระดับตำนาน \r\n บอกเลยว่า...จ๊าบบบบ \r\nใช้ปลาร้าเชฟไพรฑูรย์ สูตรนัวกลมกล่อม",
    process: [
      "วัตถุดิบ",
      "• เนื้อวัวส่วนสันนอก",
      "• ข้าวคั่ว",
      "• พริกแห้งป่น",
      "• ดีวัว แท้ตราเชฟไพรฑูรย์",
      "• น้ำปลาร้าเชฟไพรฑูรย์ สูตรนัวกลมกล่อม",
      "• ต้นหอมและผักชี",
      "• ผักชีฝรั่ง",
      "• ใบมะกรูดซอย",
      "• ผักเคียง เช่น ใบโหระพา กะหล่ำปลี แตงกวาหรือผักต่างๆตามความชอบ",
      "",
      "วิธีทำ",
      "1. นำหอมแดงมาซอยแล้วพักไว้ ตามด้วยการซอยต้นหอมและผักชีแล้วพักไว้ จากนั้นนำผักชีฝรั่งมาซอยแล้วพักไว้",
      "2. นำเนื้อวัวมาหั่นตามแนวยาวให้เป็นเส้น ๆ ก่อนหั่นตามขว้างของเนื้อ เพื่อให้เนื้อเยื่อขาดและเนื้อวัวจะได้ไม่เหนียว หั่นเป็นชิ้นเล็ก ๆ เครื่องลาบจะได้เข้าเนื้อและกินง่าย หรือสับให้ละเอียด",
      "3. นำเนื้อวัวที่หั่นแล้ว ใส่ลงในชามผสม ตามด้วยพริกแห้งป่น ดีวัวแท้ตราเชฟไพรฑูรย์ น้ำปลาร้าเชฟไพรฑูรย์ สูตรนัวกลมกล่อม และข้าวคั่ว จากนั้นคลุกเคล้าให้เข้ากัน แล้วใส่ใบมะกรูดซอย หอมแดงซอย ผักชีฝรั่งซอย ต้นหอมและผักชีซอย แล้วคลุกเคล้าให้เข้ากันอีกครั้ง",
      "4. ตักใส่จานที่ต้องการจัดเสิร์ฟ เสิร์ฟคู่กับใบโหระพา กะหล่ำปลี แตงกวา และข้าวเหนียวร้อน ๆ",
    ],
    galleryImages: [
      "/images/recommended-menus/koi-nuea-wua/01.jpg",
      "/images/recommended-menus/koi-nuea-wua/02.jpg",
      "/images/recommended-menus/koi-nuea-wua/03.jpg",
      "/images/recommended-menus/koi-nuea-wua/04.jpg"
    ],
  },
};

export const homeRecommendedMenus = {
  "เนื้อย่างซอสแจ่วปลาร้า": {
    id: 1,
    imageCover: "/images/recommended-menus/home/neaufoyawng_1.jpg",
    name: "เนื้อย่างซอสแจ่วปลาร้า",
    image: [],
    Description: "แซ่บย้อนวัย ด้วยน้ำปลาร้าแซ่บระดับตำนาน \r\n บอกเลยว่า...จ๊าบบบบ \r\nใช้ปลาร้าเชฟไพรฑูรย์ สูตรนัวกลมกล่อม",
    process: [
      "วัตถุดิบ",
      "• เนื้อวัวส่วนสันนอก 300 กรัม ",
      "• พริกป่น 1 ช้อนโต๊ะ",
      "• ข้าวคั่ว 1 ช้อนโต๊ะ",
      "• ต้นหอม (ใส่ตามความชอบ)",
      "• ผงชูรส (ใส่หรือไม่ใส่ก็ได้ตามความชอบ)",
      "• ปลาร้าเชฟไพรฑูรย์ สูตรนัวกลมกล่อม 4 ช้อนโต๊ะ ",
      "• ดีวัวแท้ ตราเชฟไพรฑูรย์ (ตามความชอบ)",
      "",
      "วิธีทำ",
      "1. หมักเนื้อวัวสันนอกกับ พริกป่น ข้าวคั่ว น้ำปลาร้าเชฟไพรฑูรย์ และดีวัวแท้ตราเชฟไพรฑูรย์ ตามส่วนผสมข้างต้น หมักทิ้งไว้ 10 นาที",
      "2. นำเนื้อไปจี่บนกระทะที่ไฟแรงจัด ด้านละ 3 นาที ",
      "3. นำเนื้อขึ้นจากกระทะ พักเนื้อทิ้งไว้ 5-10 นาที ",
      "4. หั่นเนื้อเป็นชิ้นพอดีคำ พร้อมเสิร์ฟ ทานคู่กับผักสด หรือข้าวเหนียว",
    ],
    galleryImages: [
      "/images/recommended-menus/neaufoyawng_1.jpg",
      "/images/recommended-menus/neaufoyawng_2.jpg",
      "/images/recommended-menus/neaufoyawng_3.jpg",
      "/images/recommended-menus/neaufoyawng_4.jpg"
    ],
  },
  "เหลาไหลบัวกุ้งทูโทน": {
    id: 2,
    imageCover: "/images/recommended-menus/yam_gung_tu_ton_1.jpg",
    name: "เหลาไหลบัวกุ้งทูโทน",
    image: [],
    Description: "แซ่บย้อนวัย ด้วยน้ำปลาร้าแซ่บระดับตำนาน \r\n บอกเลยว่า...จ๊าบบบบ \r\nใช้ปลาร้าเชฟไพรฑูรย์ สูตรนัวกลมกล่อม",
    process: [
      "วัตถุดิบ",
      "• กุ้งขาว 500 กรัม ",
      "• ไหลบัว 100 กรัม",
      "• พริกสด พริกแห้ง 8-10 เม็ด",
      "• มะนาว 1 ลูก ",
      "• มะเขือเทศ 5 ลูก",
      "• น้ำปลาร้าเชฟไพรฑูรย์สูตรออริจินอล 3 ทัพพี ",
      "• น้ำตาลปี๊บ 1 ช้อนโต๊ะ ",
      "• ผงชูรส (ใส่หรือไม่ใส่ก็ได้ตามความชอบ)",
      "• โซดา 1 ขวด",
      "",
      "วิธีทำ",
      "1. ปลอกเปลือกกุ้ง ผาหลังเอาเส้นหลังออก และล้างน้ำให้สะอาด",
      "2. นำกุ้งแช่น้ำโซดา 10 นาที ",
      "3. แบ่งกุ้งออกมาลวก 250 กรัม ลวกในน้ำเดือดจัด 2-3 นาที จดตัวกุ้งเป็นสีขาวขุ่น และน็อคน้ำเย็นจัดทันที",
      "4. โขลกพริกพอแหลกใส่ส่วนผสม มะเขือเทศ น้ำมะนาว น้ำตาลปี๊บตามอัตราส่วนด้านบน โขลกส่วนผสมให้เข้ากัน ",
      "5. ใส่น้ำปลาร้าเชฟไพรฑูรย์ 3 ทัพพี คนน้ำปลาร้ากับส่วนผสมให้เข้ากันอีกครั้ง ",
      "6. ชิมรสชาติ : ปรับ เปรี้ยว เค็ม หวาน ตามความชอบ",
      "7. ใส่วัตถุดิบหลัก ไหลบัว กุ้งสด กุ้งสุก ขอมแขก ผักชีใบเรื่อย และคนให้เข้ากัน",
      "8. ตักเสิร์ฟ ทาคู่กับผักสด แคบหมู และขนมจีน ตามความชอบ",
    ],
    galleryImages: [
      "/images/recommended-menus/yam_gung_tu_ton_1.jpg"
    ],
  },
  "หมกหน่อไม้ใส่หมู 3 ชั้น": {
    id: 3,
    imageCover: "/images/recommended-menus/home/mok_no_mai_1.jpg",
    name: "หมกหน่อไม้ใส่หมู 3 ชั้น",
    image: [],
    Description: "แซ่บย้อนวัย ด้วยน้ำปลาร้าแซ่บระดับตำนาน \r\n บอกเลยว่า...จ๊าบบบบ \r\nใช้ปลาร้าเชฟไพรฑูรย์ สูตรพลัสเพิ่มเนื้อปลา 30%",
    process: [
      "วัตถุดิบ",
      "• หน่อไม้ลวก 1 กิโลกรัม ",
      "• หมูสามชั้นหั่นชิ้น 3 ขีด ",
      "• ข้าวเบือ 3 ช้อนโต๊ะ",
      "• พริกกะเหรี่ยง 15 เม็ด ",
      "• กระชาย 5 หัว",
      "• ตะไคร้ 2 ต้น  ",
      "• หอมแดง 3-5 หัว ",
      "• ใบมะกรูดฉีก 10 ใบ ",
      "• น้ำใบย่านาง 5 ทัพพี ",
      "• น้ำปลาร้าสูตรพลัสเพิ่มเนื้อปลา 30 %  2 ทัพพี",
      "• น้ำปลา 1 ช้อนโต๊ะ ",
      "• ใบแมงลัก 1 มัด  ",
      "",
      "วิธีทำ",
      "1. นำหน่อไม้ต้มมาขูดให้เป็นเส้น ๆ จากนั้นใช้มีดตัดให้ได้ความยาวประมาณ 3 นิ้ว แล้วนำมาพักไว้ ",
      "2. นำข้าวเบือลงครก โขลกให้ละเอียด และตักพักไว้ และนำพริกกะเหรี่ยง หอมแดง กระชายลงคลก โขลกให้พอแหลก และตะไคร้ทุบบุบๆ",
      "3. นำหน่อไม้ที่เคล้ากับเครื่องแกงใส่ลงในหม้อ จากนั้นใส่หมูสามชั้นหั่นชิ้นลงไป ปรุงรสด้วยน้ำใบย่านาง น้ำปลาร้าเชฟไพรฑูรย์ สูตรพลัสเพิ่มเนื้อปลา 30 % คลุกเคล้าให้เข้ากัน ",
      "4. ตั้งไฟกลาง และคอยคนบ่อยๆเพราะอาจจะติดก้นหม้อและไหม้ได้ ",
      "5. เมื่อหมูสุกแล้ว ใส่ใบมะกรูด และใบแมงลักลงไป คนให้เข้ากันและปิดไฟพร้อมเสิร์ฟ",
      "6. ตักเสิร์ฟทานคู่กับผักสด และข้าวเหนียวหรือข้าวสวยตามความชอบ",
      "",
      "เคล็ดลับ",
      "• ถ้าหน่อไม้เปรี้ยวหรือมีกลิ่นให้นำไปต้มหลาย ๆ น้ำจนกลิ่นหาย ",
      "• ข้าวเบือ คือนำข้าวสารข้าวเหนียวมาแช่ในน้ำให้อ่อนตัว ข้าวเบือนั้นจะช่วยทำให้อาหารมีความข้นมากขึ้น ",
      "• ใช้น้ำปลาร้าเชฟไพรฑูรย์สูตรพลัสเพิ่มเนื้อปลา จะทำให้หมกหน่อไม้ เข้มข้น รสชาติจัดจ้าน สไตล์อีสานขนานแท้",
    ],
    galleryImages: [
      "/images/recommended-menus/mok_no_mai_1.jpg",
      "/images/recommended-menus/mok_no_mai_2.jpg",
      "/images/recommended-menus/mok_no_mai_3.jpg",
      "/images/recommended-menus/mok_no_mai_4.jpg"
    ],
  },
  "ปลาดุกต้มน้ำปลาร้าทรงเครื่อง": {
    id: 4,
    imageCover: "/images/recommended-menus/home/tom_pla_duk_1.jpg",
    name: "ปลาดุกต้มน้ำปลาร้าทรงเครื่อง",
    image: [],
    Description: "แซ่บย้อนวัย ด้วยน้ำปลาร้าแซ่บระดับตำนาน \r\n บอกเลยว่า...จ๊าบบบบ \r\nใช้ปลาร้าเชฟไพรฑูรย์ สูตรพลัสเพิ่มเนื้อปลา 30%",
    process: [
      "วัตถุดิบ",
      "• ปลาดุกหั่นแว่น 1 กก",
      "• ข่า 5 แว่น",
      "• ตะไคร้ 3 ต้น",
      "• กระชาย 9 หัว",
      "• หอมแดง 9 หัว",
      "• กระเทียมจีน 10 กลีบ",
      "• ใบมะกรูดฉีก 7 ใบ",
      "• พริกแห้งคั่ว (ตามใจชอบ)",
      "• ต้นหอมซอย 3 ต้น",
      "• น้ำปลาร้าเชฟไพรฑูรย์สูตรพลัสเพิ่มเนื้อปลา 30 %  1 ถ้วยตวง",
      "• น้ำสะอาด 2 ลิตร",
      "• พริกลูกโดด (ตามความชอบ)",
      "",
      "วิธีทำ",
      "ขั้นตอนการเตรียมเนื้อปลา",
      "1. นำเกลือมาคลุกกับเนื้อปลาให้ทั่ว ล้างด้วยน้ำสะอาด 1 น้ำ",
      "2. นำน้ำซาวข้าวมาล้าง เทน้ำออก ล้างปลาด้วยน้ำสะอาดอีก 1 รอบ",
      "3. นำน้ำเดือดจัด มาราดบนตัวปลา เทน้ำออก",
      "4. บุบข่า ตะไคร้ หอมแดง กระเทียม กระชาย ให้พอแตก (บุบทีละอย่างนะคะ)",
      "5. คั่วพริกแห้งด้วยไฟอ่อนให้หอม จากนั้นนำไปตำหยาบๆ",
      "6. ฉีกใบมะกรูด หั่นต้นหอมเตรียมไว้",
      "7. ต้มน้ำจนเดือด ใส่น้ำปลาร้าเชฟไพรฑูรย์สูตรพลัสเพิ่มเนื้อปลา 30 %  ลงไป น้ำเดือดอีกครั้ง ใส่ข่า ตะไคร้ ใบมะกรูด กระชาย กระเทียม หอมแดง",
      "8. เมื่อน้ำเดือดอีกครั้ง ใส่เนื้อปลาลงไป ช้อนฟองออกเรื่อยๆ",
      "9. เมื่อเนื้อปลาสุกดีแล้ว ใส่ใบมะกรูดอีกรอบ เพื่อความเขียวสวยงาม ใส่พริกแห้งคั่ว ลูกโดด ต้นหอมซอย ปิดไฟ พร้อมเสิร์ฟ",
      "10. จัดเสิร์ฟทานคู่กับผักสด ข้าวสวย หรือขนมจีน ตามความชอบ",
      "",
      "เคล็ดลับ",
      "• ก่อนทานแนะนำโรยพริกป่นลงไปตามความชอบจะช่วยเพิ่มความหอมและความแซ่บมากยิ่งขึ้น",
    ],
    galleryImages: [
      "/images/recommended-menus/tom_pla_duk_1.jpg"
    ],
  }
};

export const allTimeFavorites = [
  recommendedMenus["เนื้อย่างซอสแจ่วปลาร้า"],
  recommendedMenus["เหลาไหลบัวกุ้งทูโทน"],
  recommendedMenus["หมกหน่อไม้ใส่หมู 3 ชั้น"],
  recommendedMenus["ปลาดุกต้มน้ำปลาร้าทรงเครื่อง"],
];

export const otherDishes = [
  recommendedMenus["เนื้อย่างซอสแจ่วปลาร้า"],
  recommendedMenus["เหลาไหลบัวกุ้งทูโทน"],
  recommendedMenus["หมกหน่อไม้ใส่หมู 3 ชั้น"],
  recommendedMenus["ปลาดุกต้มน้ำปลาร้าทรงเครื่อง"],
  recommendedMenus["ขนมจีนน้ำยาปลาดุก"],
  recommendedMenus["อ่อมปูนา"],
  recommendedMenus["ตำลาวกุ้งเต้น"],
  recommendedMenus["สามชั้นย่างซอสน้ำปลาร้า"],
  recommendedMenus["ตำซั่วเล็บมือนาง"],
  recommendedMenus["ก้อยเนื้อวัว"],
];

export const homeAllTimeFavorites = [
  homeRecommendedMenus["เนื้อย่างซอสแจ่วปลาร้า"],
  homeRecommendedMenus["เหลาไหลบัวกุ้งทูโทน"],
  homeRecommendedMenus["หมกหน่อไม้ใส่หมู 3 ชั้น"],
  homeRecommendedMenus["ปลาดุกต้มน้ำปลาร้าทรงเครื่อง"],
];